import {Component, Input, ViewEncapsulation} from '@angular/core';
import {CplUserStatus} from '../../../supervision-management/compliance-items/compliance-item/enums/cpl-user-status.enum';
@Component({
    selector:    'status-indicator',
    templateUrl: './status-indicator.component.html',
    styleUrls:   ['./status-indicator.component.scss']
})
export class StatusIndicatorComponent {
    @Input() statusId: number;
    @Input() statusLabel: string;  


    CplUserStatus = CplUserStatus;

    getIcon() {
        switch(this.statusId) {
            case CplUserStatus.NONE:
            case CplUserStatus.DEFAULT:
            case CplUserStatus.PENDING:
                return 'far fa-square';
            case CplUserStatus.VERIFIED:
                return 'fas fa-check';
            case CplUserStatus.EXPIRING:
            case CplUserStatus.EXPIRED:
                return 'fas fa-exclamation';
            case CplUserStatus.DECLINED:
                return 'fas fa-times';
            case CplUserStatus.FORGIVEN:
            case CplUserStatus.COMPLETE_NOTALL_APPROVED:
                return 'fas fa-asterisk';
            default:
                return '';
        }
    }
}